import React, { useEffect, useState, Fragment, useRef } from 'react'
import { Card, Col, Container, Form, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {formatearNumero, validaNumeros} from '../../../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import Mensajes from '../../../mensajes';

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}
const GastosHonorarios = ({ formik, isLimpiar, setIsLimpiar, setMiMontoNOFormato, showToastAnular, setShowToastAnular, showToast, setShowToast, setIsGastoHonorario}) => {
  
  const fileRef = useRef();
  const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
  const { datosGestionImplicado } = data_proceso_extrajudicial
  const data_judicial = useSelector((state) => state.procesoJudicialReducer)
  const {cleanRef, cfg_form22,comboTipoGasto, respuestaTipoGastos,respuestaAnular,loadingGastos} = data_judicial

  const { codMonedaLocal,monedaLocal } = Auth.currentUser()
  const [fechaSiniestro, setFechaSiniestro] = useState('')
  
  //Gastos
  const [tipoGasto, setTipoGasto] = useState('')
  const [cobertura, setCobertura] = useState('')
  const [moneda, setMoneda] = useState('')
  const [monto, setMonto] = useState('')
  const [montoNoFormato, setMontoNoFormato] = useState('')
  const [fechaOcurrencia, setFechaOcurrencia] = useState(hoy())
  const [comentario, setComentario] = useState('')
  const [miTipoGestion, setMiTipoGestion] = useState('')

  const dispatch = useDispatch()
  
  useEffect(()=>{
    setFechaSiniestro(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat'] )
    setMiTipoGestion(datosGestionImplicado && parseInt(datosGestionImplicado.datosGestionImplicado[0]["codTipoGestion"]))
  },[datosGestionImplicado])


useEffect(() => {
  setMiMontoNOFormato(montoNoFormato)
}, [montoNoFormato])

useEffect(()=>{
  if(cleanRef){      
      fileRef.current.value = "";
  }
},[cleanRef])

useEffect(()=>{
  setMoneda(codMonedaLocal)
},[codMonedaLocal])

useEffect(()=>{
  if(isLimpiar){
    fileRef.current.value = "";
    setTipoGasto('')
    setCobertura('')
   
    setMonto('')
    setFechaOcurrencia(hoy())
    setComentario('')
    setIsLimpiar(false)
  }
  
},[isLimpiar])
const handleCloseToast = () => {
  setShowToast(false);
}
const handleCloseToastAnular = () => {
  setShowToastAnular(false);
}
  return (
    <>
      <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
      </style>

      <LoadingComponent show={loadingGastos}/>
        <Card>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form22
              ? cfg_form22.cfg_form22['modal-gastos-title']
              : ''}
          </Card.Header>
          <Container>
            <Container>
              {cfg_form22 ? (
                <div>
                  
                  <Row>
                    <Col md='3'>
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form22?cfg_form22.cfg_form22['modal-gastos-cmb-tipogasto']+" *":''}
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setTipoGasto(e.target.value)
                          let cob = comboTipoGasto && comboTipoGasto?.comboTipoGasto.find(c => c.id === parseInt(e.target.value))?.glosaAgrupacion                          
                          setCobertura(cob); setIsGastoHonorario(e.target.value == 244010)//Honorarios Profesionales                  
                        }}
                        name='tipoGasto'
                       value={(formik.values.tipoGasto = tipoGasto)}
                       error={formik.errors.tipoGasto}
                      >
                        <option value={''}>Seleccione...</option>  
                        {comboTipoGasto &&
                          comboTipoGasto.comboTipoGasto?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.tipoGasto ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoGasto}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col md='2'>
                      <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form22?cfg_form22.cfg_form22['modal-gastos-cmb-cobertura'] + ' *':''}
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3'>
                        {cobertura && cobertura}
                      </Form.Text>
                    </Col>
                    <Col md='2'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form22?cfg_form22.cfg_form22['modal-gastos-cmb-moneda'] +" *":''}
                      </Form.Label>
                      <br />
                      <Form.Select
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setMoneda(e.target.value)
                        }}
                        name='moneda'
                        value={
                          (formik.values.moneda = moneda)
                        }
                        error={formik.errors.moneda}
                      >
                       
                        <option value={codMonedaLocal}>{monedaLocal}</option>
                        
                      </Form.Select>
                      {formik.errors.moneda ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.moneda}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    
                 </Col>
                    <Col md='2'>
                      <Form.Label
                        className='mb-2 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                        {cfg_form22?cfg_form22.cfg_form22['modal-gastos-input-monto']+" *":''}
                      </Form.Label>{' '}
                      <br />
                      <Form.Control
                        className='mb-0'
                        autoComplete='off'
                        value={(formik.values.monto = monto)}
                        name='monto'
                        onKeyDown={(e) => validaNumeros(e)}
                        onBlur={() =>
                          setMonto(formatearNumero(montoNoFormato, !moneda == 30001))
                        }
                        onFocus={() => setMonto(montoNoFormato)}
                        onChange={(e) => {
                          formik.handleChange(e)
                          setMonto(e.target.value)
                          setMontoNoFormato(e.target.value)
                        }}
                        error={formik.errors.monto}
                        ></Form.Control>
                        {formik.errors.monto ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.monto}
                        </Form.Text>
                        ) : (
                          ''
                        )}
                    </Col>
                    <Col md='2'>
                        <Form.Label
                          className='mb-2 mt-3'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                          {cfg_form22?cfg_form22.cfg_form22['modal-gastos-input-ocurre'] +" *":''}
                        </Form.Label>{' '}
                        <br />
                        <Form.Control
                          className='mb-0'
                          type='date'
                          value={
                            (formik.values.fechaOcurrencia = fechaOcurrencia)
                          }
                          // min={
                          //   fechaSiniestro &&
                          //   convertirFecha(fechaSiniestroIM && fechaSiniestroIM)
                          // }
                          // max={hoy()}
                          name='fechaOcurrencia'
                          onChange={(e) => {
                            formik.handleChange(e)
                            setFechaOcurrencia(e.target.value)
                          }}
                          error={formik.errors.fechaOcurrencia}
                        ></Form.Control>
                        {formik.errors.fechaOcurrencia ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.fechaOcurrencia}
                          </Form.Text>
                        ) : (
                          ''
                        )}                        
                    </Col>
                  </Row>
                  <Row>
                      <Col md='5'>
                        <Form.Label
                          className='mt-3'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                          {cfg_form22?cfg_form22.cfg_form22['modal-gastos-input-comentario']:''}
                        </Form.Label>
                        <br />
                        <Form.Control
                          as='textarea'
                          className='mb-2'
                          rows={3}
                          onChange={(e) => {
                            formik.handleChange(e)
                            setComentario(e.target.value)
                          }}
                          name='comentario'
                          value={
                            (formik.values.comentario =
                              comentario)
                          }
                          error={formik.errors.comentario}
                        />
                        {formik.errors.comentario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.comentario}
                          </Form.Text>
                        ) : (
                          ''
                        )}
                      </Col>    
                      <Col md='7'>
                        <Form.Label className='mt-3'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form22 ? cfg_form22.cfg_form22['modal-gastos-lbl-docto'] +" *":''}
                        </Form.Label>
                        <Form.Group className="position-relative mb-2 mt-1">
                          <Form.Control ref={fileRef} type="file" name="file"
                              onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                              isInvalid={!!formik.errors.file}
                              isValid={formik.touched.file && !formik.errors.file}
                          />
                          <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                          <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                        </Form.Group>
                      </Col>  
                    </Row>
                    <Row className="mt-1">
                      <Col md="8"></Col>
                      <Col >
                        {respuestaTipoGastos && 
                          <Mensajes
                              showToast={showToast}
                              handleCloseToast={handleCloseToast}
                              delay={5000}
                              responseData={respuestaTipoGastos?.respuestaTipoGastos}
                          ></Mensajes>
                        }
                        {respuestaAnular && 
                          <Mensajes
                              showToast={showToastAnular}
                              handleCloseToast={handleCloseToastAnular}
                              delay={5000}
                              responseData={respuestaAnular?.respuestaAnular}
                          ></Mensajes>
                        }
                      </Col>
                    </Row>                  
                  {/*<hr style={{color: '#04005D', height: '2px', marginTop: '30px'}}></hr>*/}
                </div>
              ) : null}
            </Container>
          </Container>
        </Card>
      
    </>
  )
}

export default GastosHonorarios
